let IntentosPost = 0;
const Post = (url, body, resp) => {
    fetch(url, {
        method: 'POST', 
        body: JSON.stringify(body),
        headers:{'Content-Type' : 'application/json', 'charset' : 'UTF-8'},
        })
    .then(response => {response.text().then(respuesta);
        function respuesta(data) {
            resp (data);
        }
    },error => {
        IntentosPost++;
        (IntentosPost > 5) ? IntentosPost = 0 : Post(url, body, (respuesta) => {
            resp(respuesta)
        })
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    })

    /* var myHeaders = new Headers();
    myHeaders.append("accept", "application/json");

    var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    redirect: 'follow',
    body: JSON.stringify(body),
    };

    fetch(url, requestOptions)
    .then(response => response.text())
    .then(result => resp (result))
    .catch(error => {
        IntentosPost++;
        (IntentosPost > 5) ? IntentosPost = 0 : Post(url, body, (respuesta) => {
            resp(respuesta)
        })
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    }); */
}

export default Post;


// WEBPACK FOOTER //
// ./src/shared/Post.jsx